module.exports = __webpack_public_path__ + "static/talk1-fd7cd9f2f0bbaad5d977634d7e9ea08a.png";